import {MainContainer} from '../../assets/ts/layout/main';
import {ContentContainer} from '../../assets/ts/layout/content';
import {Language} from '../../assets/ts/customTypes';
import {
    HexagonTextWrapper,
    HexagonBackgroundWrapper,
    HexagonImages,
    ContentHeadline,
    ContentIntro,
    ContentText,
    ContentIcon
} from '../../assets/ts/pages/infopage';
import {getRelativeWidth} from '../../config';
import HexagonTextBGFull from '../../assets/backgrounds/bg-hexa.svg';
import HexagonTextBGFrame from '../../assets/backgrounds/bg-hexa-frame.svg';
import {ContentInfoBox} from '../components/ContentInfoBox';
import {InfoBox} from '../../assets/ts/customTypes';
import {InfoPageHexagonImage} from '../components/InfoPageHexagonImage';
import { useLanguage } from '../contexts/LanguageContext';

interface InfopageProps {
    page: keyof Language['infoPages'];
}

export function Infopage(props: InfopageProps) {
    const [language] = useLanguage();
    const page = language.infoPages[props.page];

    return (
        <MainContainer>
            <ContentContainer>
                <HexagonBackgroundWrapper width={getRelativeWidth(1154)}>
                    <img src={HexagonTextBGFull} alt='' className='background-full' />
                    <img src={HexagonTextBGFrame} alt='' className='background-frame' />
                    <ContentIcon width={getRelativeWidth(200)}>
                        {page.icon}
                    </ContentIcon>

                    <HexagonTextWrapper width={getRelativeWidth(725)}>
                        <ContentHeadline>{page.headline}</ContentHeadline>
                        {page.intro && <ContentIntro>{page.intro}</ContentIntro>}
                        <ContentText>{page.text}</ContentText>
                        {page.infoBoxes?.length && page.infoBoxes.map((box: InfoBox, key: number) => (<ContentInfoBox key={key} icon={box.icon} headline={box.headline} list={box.list}/>))}
                    </HexagonTextWrapper>

                </HexagonBackgroundWrapper>
                <HexagonImages width={getRelativeWidth(649)}>
                    <InfoPageHexagonImage currentPage={props.page}/>
                </HexagonImages>
            </ContentContainer>
        </MainContainer>
    );
}
